<nav class="align-items-center realto-navigation">
    <div class="d-flex align-items-center">
        <button class="realto-navigation-hamburger-menu-menu-button" (click)="toggleSidebar()">
            <app-svg-icon icon="menu"></app-svg-icon>
        </button>

        <ul class="d-flex realto-navigation-menu-list">
            @for (item of menuItems; track item) {
                <li class="realto-navigation-menu-list-item" [class.active]="item.isActive">
                    <a [routerLink]="[item.link]" class="realto-navigation-menu-list-item-link">
                        {{ item.name | localize }}
                    </a>
                </li>
            }
        </ul>
    </div>
    <div class="d-flex align-items-center realto-navigation-right-side">
        <app-search-input placeholder="Търси контакти, обяви, имоти..." />

        <app-svg-icon [icon]="notificationBell" class="realto-navigation-right-side-notification-icon" />
    </div>
</nav>
